import * as React from 'react'
import { cn } from '@/lib/utils'

/** Purple brand checkboxes across the main app — keep in sync only here */
const checkboxInputClassNames =
	'h-4 w-4 shrink-0 cursor-pointer rounded border-[#8c52ff] accent-[#8c52ff] text-[#8c52ff] focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0'

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	checked?: boolean
	onCheckedChange?: (checked: boolean) => void
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
	({ className, checked, onCheckedChange, onChange, ...props }, ref) => {
		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			onCheckedChange?.(e.target.checked)
			onChange?.(e)
		}

		return (
			<input
				type="checkbox"
				ref={ref}
				className={cn(checkboxInputClassNames, className)}
				checked={checked}
				onChange={handleChange}
				{...props}
			/>
		)
	}
)
Checkbox.displayName = 'Checkbox'
